const news = [
    {
        path: '/news',
        name: 'news',
        component: () => import('@/view/news/Index')
    },
    {
        path: '/news/details',
        name: 'newsDetails',
        component: () => import('@/view/news/Details')
    }
]
export default news